import Joi from "joi";

import { Fields } from "~/constants/forms";
import { EXPORT_FILE } from "~/constants/strings";

export default Joi.object().keys({
  [Fields.DATE]: Joi.string(),
  [Fields.EXPORT_FILE]: Joi.string().max(200).required().label(EXPORT_FILE),
});
